interface ToolCardAddressProps {
  address: string | null;
}

const ToolCardAddress = ({ address }: ToolCardAddressProps) => {
  if (!address) return null;

  return (
    <p className="text-sm text-gray-500 flex items-center gap-2 group-hover:text-gray-700 transition-colors">
      <span className="inline-flex items-center justify-center w-4 h-4">
        📍
      </span>
      {address}
    </p>
  );
};

export default ToolCardAddress;